<template>
  <div class="detalhes-por-area">
    <div class="row">
      <PublicHeader :title="secretaria">
        <div class="col-xs-12 col-sm-6">
          <p>
            A <ValorDestaqueHeader :value="secretaria" /> recebeu, no ano de
            <SelectAnoEmendas /> , um total de
            <ValorDestaqueHeader
              :value="formatarMoeda(valorTotalSecretaria)"
              :isLoading="loading"
            />
            em emendas parlamentares.
          </p>
          <p>
            Do total,
            <ValorDestaqueHeader
              :value="utilizadosComPercentual"
              :isLoading="loading"
            />
            foram utilizados, restando um saldo de
            <ValorDestaqueHeader
              :value="saldoComPercentual"
              :isLoading="loading"
            />
            .
          </p>
        </div>
      </PublicHeader>
    </div>
    <div class="row">
      <div class="container">
        <Breadcrumb :links="breadcrumb" />
        <div class="row">
          <div class="col-xs-12">
            <h3>
              Lista de emendas
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6">
            <input
              type="text"
              class="form-control"
              placeholder="Digite o nome do vereador ou descrição..."
              aria-placeholder="Digite o nome do vereador ou descrição..."
              v-model="filtros.descricao"
            />
          </div>
          <div class="col-xs-12 col-sm-6 text-right">
            <button class="btn btn-default" @click="downloadToCSV()">
              <font-awesome-icon :icon="'file-download'" /> Exportar para CSV
            </button>
          </div>
          <div class="col-xs-12">
            <DataTable :dados="emendasDaSecretaria" :fields="dataFields">
              <template slot="rowrender" slot-scope="props">
                <button
                  title="Exibir detalhes"
                  type="button"
                  class="btn btn-primary"
                  @click="showDetails(props.rowData)"
                >
                  <font-awesome-icon :icon="'search'"></font-awesome-icon>
                  <span class="sr-only">Exibir detalhes</span>
                </button>
              </template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <SideEmendas ref="side-emendas" :emenda="emendaSelecionada" :navs="navs" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  PublicHeader,
  Breadcrumb,
  NoApiTable as DataTable,
  SideEmendas,
  SelectAnoEmendas,
  ValorDestaqueHeader
} from '../../../components'
import { formatarMoeda, exportCSVFile } from '../../../utils'
import { navs, dataFields } from './emendasGeral'
import { mapGetters } from 'vuex/dist/vuex.common.js'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    DataTable,
    SideEmendas,
    SelectAnoEmendas,
    ValorDestaqueHeader
  },
  data() {
    return {
      secretaria: 'Secretaria selecionada',
      emendaSelecionada: {},
      breadcrumb: [],
      navs,
      dataFields,
      filtros: {
        descricao: ''
      }
    }
  },
  created() {
    const { secretaria } = this.$route.params
    this.secretaria = secretaria

    this.fillBreadcrumb()
  },
  methods: {
    showDetails(emenda) {
      const [nav] = this.navs

      nav.titulo = `Detalhes da emenda`
      nav.subtitulo = `Emenda nº ${emenda.numero} / ${emenda.ano}`
      nav.subtDetalhe = emenda.nome_orgao
      this.emendaSelecionada = emenda

      this.$refs['side-emendas'].$emit('abreModal', nav.identidade)
    },
    getPercent(parte, todo) {
      if (todo) {
        return ((parte / todo) * 100).toLocaleString(undefined, {
          maximumFractionDigits: 1
        })
      }

      return '0'
    },
    fillBreadcrumb() {
      this.breadcrumb = [
        {
          label: 'Emendas Parlamentares',
          named_link: { name: 'emendas_parlamentares' }
        },
        {
          label: 'Emendas Por Secretaria',
          named_link: { name: 'emendas_por_area' }
        },
        {
          label: this.secretaria
        }
      ]
    },
    formatarMoeda,
    downloadToCSV() {
      const headers = {
        numero: 'Emenda nº',
        vereador: 'Vereador',
        secretaria: 'Secretaria',
        descricao: 'Descrição',
        valor: 'Valor',
        saldo: 'Saldo'
      }

      exportCSVFile(
        headers,
        [
          ...this.emendasDaSecretaria.map(item => {
            return {
              numero: item.numero,
              vereador: item.vereador.nome,
              secretaria: item.nome_orgao,
              descricao: item.descricao,
              valor: Number(item.valor)
                .toFixed(2)
                .replace('.', ','),
              saldo: Number(item.saldo)
                .toFixed(2)
                .replace('.', ',')
            }
          })
        ],
        'emendas'
      )
    }
  },
  computed: {
    ...mapState({
      emendas: state => state.emendas_parlamentares.emendas,
      loading: state => state.emendas_parlamentares.loading
    }),
    ...mapGetters([
      'emendasPorSecretaria',
      'valorTotalPorSecretaria',
      'saldoTotalPorSecretaria'
    ]),
    utilizadosComPercentual() {
      const percentual = this.getPercent(
        this.valorTotalUtilizado,
        this.valorTotalSecretaria
      )

      return `${this.formatarMoeda(this.valorTotalUtilizado)} (${percentual} %)`
    },
    saldoComPercentual() {
      const percentual = this.getPercent(
        this.saldoTotalSecretaria,
        this.valorTotalSecretaria
      )

      return `${this.formatarMoeda(
        this.saldoTotalSecretaria
      )} (${percentual.toLocaleString()} %)`
    },
    emendasDaSecretaria() {
      const emendasSecretaria = this.emendasPorSecretaria(this.secretaria)

      if (this.filtros.descricao) {
        const filter = item => {
          const { vereador, descricao } = item

          const termo = this.filtros.descricao.toUpperCase()
          return (
            vereador.nome.toUpperCase().includes(termo) ||
            descricao.toUpperCase().includes(termo)
          )
        }

        return emendasSecretaria.filter(filter)
      }

      return emendasSecretaria
    },
    valorTotalSecretaria() {
      return this.valorTotalPorSecretaria(this.secretaria)
    },
    saldoTotalSecretaria() {
      return this.saldoTotalPorSecretaria(this.secretaria)
    },
    valorTotalUtilizado() {
      return this.valorTotalSecretaria - this.saldoTotalSecretaria
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/emendas_parlamentares/DetalhesPorArea.vue